import styled from 'styled-components';

import StateAndEntitySelectSection from '_components/composed/sections/StateAndEntitySelectSection';
import CustomerFeedbackSection from '_components/composed/sections/CustomerFeedbackSection';
import WhyIncorpifiedSection from '_components/composed/sections/WhyIncorpifiedSection';
import BenefitsSection from '_components/composed/sections/BenefitsSection';
import QuoteSection from '_components/composed/sections/QuoteSection';
import GetStartedSection from '_components/composed/sections/GetStartedSection';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HomePage = () => {
  return (
    <StyledContainer>
      <StateAndEntitySelectSection />
      <CustomerFeedbackSection />
      <WhyIncorpifiedSection />
      <BenefitsSection />
      <QuoteSection />
      <GetStartedSection />
    </StyledContainer>
  );
};

export default HomePage;
